import React from "react";
import { useTranslation } from "react-i18next";
import { EventFormValues } from "../utils/eventForm";

interface EventFieldsProps {
  values: EventFormValues;
  onChange: (values: EventFormValues) => void;
  disabled?: boolean;
  /** The title is ready to type in as soon as the fields appear. */
  focusTitle?: boolean;
}

const INPUT_CLASS =
  "mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-base focus:border-transparent md:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-50";

/** Title, date, time and place of an event, shown above the text of the post. */
export function EventFields({ values, onChange, disabled = false, focusTitle = false }: EventFieldsProps) {
  const { t } = useTranslation();
  const field = (name: keyof EventFormValues) => ({
    value: values[name],
    disabled,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => onChange({ ...values, [name]: e.target.value }),
    className: INPUT_CLASS,
  });

  return (
    <div className="mb-3 grid grid-cols-2 gap-3 rounded-lg border border-gray-200 bg-gray-50 p-3" data-testid="event-fields">
      <label className="col-span-2 text-sm font-medium text-gray-700">
        {t("news_event_title_label")}
        <input type="text" required maxLength={200} autoFocus={focusTitle} {...field("title")} />
      </label>
      <label className="text-sm font-medium text-gray-700">
        {t("news_event_date_label")}
        <input type="date" required {...field("date")} />
      </label>
      <label className="text-sm font-medium text-gray-700">
        {t("news_event_time_label")}
        <input type="time" required {...field("time")} />
      </label>
      <label className="col-span-2 text-sm font-medium text-gray-700">
        {t("news_event_location_label")}
        <input type="text" maxLength={200} {...field("location")} />
      </label>
    </div>
  );
}
